var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pages)?_c('div',{staticClass:"orderspagination"},_vm._l((_vm.pages),function(index){return _c('span',{key:index,staticClass:"orderspagination__page",class:{ 'current': (index == _vm.current)},on:{"click":function($event){return _vm.goToPage(index)}}},[_vm._v(" "+_vm._s(index)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }